import React from 'react';

export default ({ sale }) => {
  return (
    sale.expiredPackages && (
      <div className="expire-alert">
        <div className="expire-alert__head">
          The items in your cart expired.
        </div>
      </div>
    )
  );
};
